import { create } from "zustand"
import { Notification } from "../interfaces/NotificationLog/notification"
import { endOfMonth, startOfMonth } from "date-fns"

interface NotificationTypeStore {
    showDetailNotification: boolean
    setShowDetailNotification: (showDetailNotification: boolean) => void
    detailNotification: Notification
    setDetailNotification: (detailNotification: Notification) => void
    listCheckedNotification: { id: string }[]
    setListCheckedNotification: (listCheckedNotification: { id: string }[]) => void
    startDate: Date
    setStartDate: (startDate: Date) => void
    endDate: Date
    setEndDate: (endDate: Date) => void
}

const useNotificationStore = create<NotificationTypeStore>((set) => ({
    showDetailNotification: false,
    setShowDetailNotification: (showDetailNotification) => set({ showDetailNotification }),
    detailNotification: {} as Notification,
    setDetailNotification: (detailNotification) => set({ detailNotification }),
    listCheckedNotification: [],
    setListCheckedNotification: (listCheckedNotification) => set({ listCheckedNotification }),
    startDate: startOfMonth(new Date()),
    setStartDate: (startDate) => set({ startDate }),
    endDate: endOfMonth(new Date()),
    setEndDate: (endDate) => set({ endDate })
}))

export default useNotificationStore